var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('audio',{attrs:{"id":"alarmBgm","src":_vm.$static_URL + 'static/alarm.mp3',"loop":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }